import { BaseViewStore } from 'core/stores';
import { ApplicationStore } from 'platform/application/stores';
import { WarehouseOrganizationInfoStore } from 'modules/warehouse/stores';
import { CloseOutExitForm } from 'modules/order/forms';
import { notificationError } from 'core/utils';
import { localStorageHandler } from 'core/services';
import { action, makeObservable } from 'mobx';
import { sourceOfChange } from 'common/constants';
import _ from 'lodash';
import { BaasicDropdownViewStore } from 'common/stores';

class CloseOutExitViewStore extends BaseViewStore {
	form = new CloseOutExitForm({
		onSuccess: async () => {
			await this.closeOutExit();
		},
	});

	constructor(rootStore) {
		super(rootStore);
		makeObservable(this);
		this.warehouseOrganizationInfoStore = new WarehouseOrganizationInfoStore(rootStore);
		this.initialize();
	}

	@action.bound async initialize() {
		this.suspend();
		this.warehouseDropdownStore = new BaasicDropdownViewStore({
			field: this.form.$('warehouseId'),
			store: new ApplicationStore(this.rootStore),
			itemTemplate: {
				value: 'id',
				label: 'applicationTitle',
			},
			filterProperties: {
				warehouseOnly: true,
				isOrganizationActive: true,
				useSafeQuantity: false,
			},
		});
		this.resume();
	}

	@action.bound
	async closeOutExit() {
		this.suspend();
		try {
			const response = await this.warehouseOrganizationInfoStore.closeOutExitScan(
				sourceOfChange.closeOutExitScan,
				this.form.$('warehouseId').value
			);
			if (response) {
				this.rootStore.notificationStore.success('WAREHOUSEVIEW.CLOSEOUT.EXITSCAN.SUCCESS');
			} else {
				this.rootStore.notificationStore.error('WAREHOUSEVIEW.CLOSEOUT.EXITSCAN.FAILURE');
				localStorageHandler.set('isCloseOutPalletizing', false);
				localStorageHandler.set('closeOutWarehouse', this.warehouseDropdownStore.value);
				this.rootStore.routerStore.goTo('master.app.main.order.closeout.detail');
			}
		} catch (err) {
			if (err.data) {
				this.rootStore.notificationStore.error(err.data);
			} else {
				notificationError({ store: this.rootStore.notificationStore, err });
			}
		}
		this.resume();
	}
}

export default CloseOutExitViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/CloseOutExitViewStore.js